// extracted by mini-css-extract-plugin
export var circle = "ImageWithText-module--circle--51a95";
export var wrapper = "ImageWithText-module--wrapper--a3588";